import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";
import "dotenv/config";

export const env = createEnv({
  skipValidation: process.env.SKIP_ENV_VALIDATION === "1",
  clientPrefix: "NEXT_PUBLIC_",
  client: {
    NEXT_PUBLIC_GIT_COMMIT: z.string().optional().default("dev"),
    NEXT_PUBLIC_SERVERSIDE_HOST: z.string().url(),
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: z.string(),
    NEXT_PUBLIC_WEBSOCKET_HOST: z.string().url(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string(),
    NEXT_PUBLIC_NODE_ENV: z.enum(["development", "production"]),
    NEXT_PUBLIC_SIGNALING_SERVER_URL: z.string().url(),
    NEXT_PUBLIC_AQUISITIONS_API: z.string().url(),
    NEXT_PUBLIC_TURN_SERVER: z.string(),
    NEXT_PUBLIC_TURN_SERVER_USERNAME: z.string(),
    NEXT_PUBLIC_TURN_SERVER_PASSWORD: z.string(),
    NEXT_PUBLIC_SIGNING_TOOL_ENDPOINT: z.string().url().default("http://localhost:8811"),
  },
  runtimeEnv: {
    NEXT_PUBLIC_GIT_COMMIT: process.env.NEXT_PUBLIC_GIT_COMMIT,
    NEXT_PUBLIC_SERVERSIDE_HOST: process.env.NEXT_PUBLIC_SERVERSIDE_HOST,
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
    NEXT_PUBLIC_WEBSOCKET_HOST: process.env.NEXT_PUBLIC_WEBSOCKET_HOST,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV,
    NEXT_PUBLIC_SIGNALING_SERVER_URL: process.env.NEXT_PUBLIC_SIGNALING_SERVER_URL,
    NEXT_PUBLIC_AQUISITIONS_API: process.env.NEXT_PUBLIC_AQUISITIONS_API,
    NEXT_PUBLIC_TURN_SERVER: process.env.NEXT_PUBLIC_TURN_SERVER,
    NEXT_PUBLIC_TURN_SERVER_USERNAME: process.env.NEXT_PUBLIC_TURN_SERVER_USERNAME,
    NEXT_PUBLIC_TURN_SERVER_PASSWORD: process.env.NEXT_PUBLIC_TURN_SERVER_PASSWORD,
  },
});
